import { Typography } from "antd";
const {Text, Title} = Typography;

export const highlightSearchTerm = (activityName, searchText) => {
  const term = searchText.trim();
  if (!term) return activityName;

  const lowerName = activityName.toLowerCase();
  const lowerTerm = term.toLowerCase();

  const index = lowerName.indexOf(lowerTerm);
  if (index === -1) return activityName;

  const before = activityName.slice(0, index);
  const match = activityName.slice(index, index + term.length);
  const after = activityName.slice(index + term.length);

  return (
    <Text>
      {before}
      <Text style={{ background: "yellow" }}>{match}</Text>
      {after}
    </Text>
  );
};